import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {User} from "~/lib/models/user";
import {Icon, icons} from "~/components/icon";
import {EnvConfig} from "~/lib/env-config";

@Component
export class UserBox extends Vue {

  @Getter currentUser: User;

  logout() {
    this.$store.dispatch("logout");
    this.$router.replace({name: "login"}, () => {
      this.$router.go(0);
    });
  }

  render() {
    return (
      <div class="user-box">

        <div class="current-user truncate">
          <Icon icon={icons.userAccount}/>
          <span class="email">{this.currentUser.email}</span>
        </div>

        {EnvConfig("ENABLE_LOGOUT") && (
          <a class="logout" onClick={() => this.logout()}>
            {this.$lang("general.logout")}
          </a>
        )}

      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-19febb35/user-box.tsx" });